export {};

// Taille de l'iframe quand le chat est réduit (juste le bouton)
const COLLAPSED_WIDTH = "100px";
const COLLAPSED_HEIGHT = "100px";
// Taille quand le chat est ouvert
const EXPANDED_WIDTH = "400px";
const EXPANDED_HEIGHT = "680px";

interface EmbedConfig {
    [key: string]: unknown;
    serverUrl: string;
}

const createWebchatIframe = (config: EmbedConfig): HTMLIFrameElement => {
    const iframe = document.createElement("iframe");

    const params = new URLSearchParams({ config: JSON.stringify(config) });
    iframe.src = `${config.serverUrl}?${params.toString()}`;

    iframe.style.cssText = [
        "position: fixed",
        "bottom: 0",
        "right: 0",
        `width: ${COLLAPSED_WIDTH}`,
        `height: ${COLLAPSED_HEIGHT}`,
        "border: none",
        "background: transparent",
        "z-index: 9999",
        // pointer-events géré dynamiquement pour ne pas bloquer les clics sur le CMS
        "pointer-events: none"
    ].join("; ");

    iframe.setAttribute("allow", "microphone");
    iframe.setAttribute("title", "Chat support");

    return iframe;
};

const initWebchatEmbed = (config: EmbedConfig) => {
    const iframe = createWebchatIframe(config);
    document.body.appendChild(iframe);

    window.addEventListener("message", (event: MessageEvent) => {
        if (!event.data || event.data.type !== "TWILIO_WEBCHAT_RESIZE") return;

        // Vérifie que le message vient bien de notre iframe
        if (event.source !== iframe.contentWindow) return;

        const { expanded } = event.data as { expanded: boolean };

        if (expanded) {
            iframe.style.width = EXPANDED_WIDTH;
            iframe.style.height = EXPANDED_HEIGHT;
        } else {
            iframe.style.width = COLLAPSED_WIDTH;
            iframe.style.height = COLLAPSED_HEIGHT;
        }

        // Active pointer-events uniquement sur la zone du widget pour ne pas bloquer le CMS
        iframe.style.pointerEvents = "auto";
    });

    // Active pointer-events dès le chargement de l'iframe (le bouton doit être cliquable)
    iframe.addEventListener("load", () => {
        iframe.style.pointerEvents = "auto";
    });
};

(window as unknown as { Twilio: { initWebchat: (config: EmbedConfig) => void } }).Twilio = {
    initWebchat: initWebchatEmbed
};
